import * as Styled from './locations-module.skeleton.styles';

export const LocationSkeleton = () => (
  <div data-testid="locations-skeleton">
    {/* @ts-expect-error FIXME: SC6 */}
    <Styled.MapSkeleton amountRows={3} />
  </div>
);
